import httpService from '@/modules/common/services/httpService';

const baseRoute = '/v3/sales/reports/';
const widgetDataRoute = 'payments_widget';
const forcastRoute = 'forecast_payments';

const getSalesWidgetData = async (timeRange = {}) => {
  const { startDate, endDate } = timeRange || {};
  return httpService.get(`${baseRoute}${widgetDataRoute}`, { 
    start_time: startDate,
    end_time: endDate 
  })
  .then((response) => response.data);
};

const getForecastData = async () => httpService.get(`${baseRoute}${forcastRoute}`)
  .then((response) => response.data);

export default {
  getSalesWidgetData,
  getForecastData,
};
